import SQL_SPEC from './pgTableColumnsSql.json';
import { pgEnumValues } from './dbEnumColumns';

/**
 * Postgres column metadata for a table tab. The SQL lives in JSON so the Rust
 * live test (db_postgres_enum_live_tests.rs) runs this exact text against a
 * real server — see the `_comment` there for the column positions.
 *
 * udt_name + udt_schema serve the write path's placeholder casts: data_type
 * says 'USER-DEFINED' for enums, udt_name has the real type name and
 * udt_schema qualifies it — the type may live outside the connection's
 * search_path (dbGridSql.pgCastFor). is_unique goes through pg_index (not
 * information_schema) so CREATE UNIQUE INDEX counts too, and indnkeyatts = 1
 * keeps it to single-column indexes — a member of a composite unique index is
 * not safe to blank on duplicate. enum_values are the labels in declared
 * order; an enum ARRAY column has data_type 'ARRAY' and gets none.
 */
export const PG_TABLE_COLUMNS_SQL = SQL_SPEC.lines.join(' ');

/** One result row → the tab's tableColumns entry. */
export function pgTableColumnFromRow(r) {
  return {
    name: r[0],
    type: r[1] || '',
    udtName: r[2] || '',
    udtSchema: r[4] || '',
    nullable: r[6] !== false,
    enumValues: pgEnumValues(r[7]),
  };
}
